import ICPSwapLogo from '@plug-core/assets/icons/icpswap.png'
import { SwapProvider } from '@plug-core/interfaces/swapInterface'
import { Avatar, ListGroup, ListRow } from '@ui'
import { ROUTES } from '@utils/routes'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const ProviderPicker = () => {
  const navigate = useNavigate()

  const { t } = useTranslation()

  const renderProviderRow = (provider: string, logo: string) => (
    <ListRow
      key={provider}
      onClick={() => navigate(ROUTES.SWAP_FALLBACK_PAIR_SELECT, { state: { provider } })}
      leading={<Avatar src={logo} fallback={provider} />}
      primary={provider}
      chevron
    />
  )

  return (
    <div className="mb-3 flex flex-col">
      <ListGroup>{renderProviderRow(SwapProvider.ICPSWAP, ICPSwapLogo)}</ListGroup>
    </div>
  )
}

export default ProviderPicker
